import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useReminderAnalyses from 'hooks/useReminderAnalyses';
import { reminderAnalysesSelectors } from "features/reminderAnalyses";

const ReminderAnalysesList = () => {
  const { getReminderAnalyses } = useReminderAnalyses();
  const { data, pagination } = useCustomSelector(reminderAnalysesSelectors.getReminderAnalysesData);
  const fetching = useCustomSelector(reminderAnalysesSelectors.reminderAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getReminderAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ReminderAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);